import type {RutaProd} from '../../../../runtime/rutas';
export default {ruta:'/sistema/netcom/superadmin/cobro',documento:'superadmin',acceso:'sesion',filas:['064'],cita:'Areas/Netcom/Controllers/SuperAdminController.cs:330'} satisfies RutaProd;
